import { Component, OnInit, Input, Output } from '@angular/core';
import { ControlWidget } from 'ngx-schema-form';
import { EventEmitter } from 'protractor';

@Component({
  selector: 'app-string',
  templateUrl: './string.component.html',
  styleUrls: ['./string.component.css']
})
export class StringPollWidget extends ControlWidget {
  
}
